import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'

interface Props {
  text: string
}

/**
 * A horizontal line with text in the middle.
 *
 * @param text The text to display in the middle of the line.
 */
const SeparatorLineWithText: React.FC<Props> = ({ text }) => {
  const theme = useTheme()
  const color = theme.palette.grey.grey05
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', flex: 1, width: '100%', alignItems: 'center' }}>
      <Box sx={{ width: '100%', height: '1px', backgroundColor: color }} />
      <Typography variant="body2" color={color} sx={{ px: 2 }}>
        {text}
      </Typography>
      <Box sx={{ width: '100%', height: '1px', backgroundColor: color }} />
    </Box>
  )
}

export default SeparatorLineWithText
